<!-- @veltra/icons generated sha256:d0620d02126aa80d gen:8 source:src/svg/normal/folder-opened.svg -->
<script setup lang="ts">
defineOptions({ name: 'FolderOpened' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      fill-rule="evenodd"
      d="M6.08 2.744H3.006a.51.51 0 0 1-.507-.496c0-.276.227-.504.503-.504h3.423c.227 0 .45.078.628.22l1.52 1.211c.177.141.402.22.628.22h3.803a.5.5 0 0 1-.001 1H8.848c-.226 0-.447-.079-.624-.22l-1.52-1.211a1 1 0 0 0-.625-.22M1.5 5.394a1 1 0 0 1 1-1h3.603l2.072 1.651H13.5a1 1 0 0 1 1 1V13a1 1 0 0 1-1 1h-11a1 1 0 0 1-1-1zm4.254 0H2.5V13h11V7.045H7.825z"
    />
  </svg>
</template>
